import React from "react";
import useKeyPress from "../../hooks/useKeyPress";
import "./index.scss";

export default function Input(props) {
  const {
    value,
    placeholder = "",
    onChange = () => {},
    onEnter = () => {
      console.log("Enter is pressed");
    },
    label,
    name,
    error,
    showLabel = true,
    showErrorMessage = true,
  } = props;

  useKeyPress("Enter", onEnter, value);

  return (
    <>
      {showLabel && (
        <label className="label" htmlFor={name}>
          {label}
        </label>
      )}
      <input
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="input"
        name={name}
      />
      {showErrorMessage && error?.length > 0 ? (
        <div className="error-message">{error}</div>
      ) : null}
    </>
  );
}
